import React from 'react';

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    type?: 'danger' | 'warning' | 'info';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    title,
    message,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    onConfirm,
    onCancel,
    type = 'danger'
}) => {
    if (!isOpen) return null;

    const confirmColorClass = type === 'danger' ? 'bg-red-500/80 hover:bg-red-600/80 border-red-500'
        : type === 'warning' ? 'bg-amber-500/80 hover:bg-amber-600/80 border-amber-500'
            : 'bg-blue-500/80 hover:bg-blue-600/80 border-blue-500';

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="glass-card w-full max-w-sm p-6 flex flex-col gap-4 animate-in fade-in zoom-in duration-200">
                <h3 className="text-xl font-bold text-white">{title}</h3>
                <p className="text-white/70 text-sm">
                    {message}
                </p>
                <div className="flex gap-3 justify-end mt-4">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 text-white text-sm font-semibold transition-colors"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`px-4 py-2 rounded-lg text-white text-sm font-semibold transition-colors border ${confirmColorClass}`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
